export default __webpack_public_path__ + "static/media/port3.7797cf78.png";